import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BzgToastService } from 'bz-genome-angular';
import { ChangePasswordAdminService } from './core/change-password-admin.service';

@Component({
    selector: 'change-password-admin',
    templateUrl: 'change-password-admin.component.html',
    styleUrls: ['change-password-admin.component.scss']
})
export class ChangePasswordAdminComponent {
    changingPassword: boolean;
    password: string;
    verificationPassword: string;

    constructor(private _translateService: TranslateService,
        private _toastService: BzgToastService,
        private _changeAdminPasswordService: ChangePasswordAdminService
    ) { }

    ngOnInit() {

    }

    public async changeAdminPassword() {
        this.changingPassword = true;
        await this._changeAdminPasswordService.changeAdminPassword(this.password);
        this._translateService.get('CHANGE_PASSWORD_ADMIN.SUCCESS_MSG').subscribe((message: string) => {
            this._toastService.open(
                message,
                {
                    type: 'success',
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'right'
                });
        });
        this.changingPassword = false;

    }

    public isPasswordInvalid(): boolean {
        return !this.password || !this.verificationPassword || this.verificationPassword !== this.password;
    }

    public cancel() {
        this.password = '';
        this.verificationPassword = '';
    }
}
